import { createContext } from 'react';

// Create and export context
export const AuthenticationContext = createContext({
  loggedIn: false,
  setLoggedIn: () => {},
});